import {
    Button,
    Dialog,
    DialogActions,
    DialogProps,
    Typography,
} from '@mui/material'
import { FC } from 'react'
import { getPxAsRem } from 'shared/utils'

export interface UnsavedChangesModalProps extends Omit<DialogProps, 'open'> {
    message?: string
    onLeaveClick?: () => void
    onStayClick?: () => void
    open?: boolean
}

const UnsavedChangesModal: FC<UnsavedChangesModalProps> = ({
    message = 'You have unfinished sections. If you leave now, your progress will be lost.',
    open = false,
    onLeaveClick,
    onStayClick,
    ...props
}) => {
    return (
        <Dialog {...props} open={open}>
            <Typography sx={{ padding: getPxAsRem(16, 24) }} variant="h6">
                Warning
            </Typography>
            <Typography sx={{ padding: getPxAsRem(0, 24, 20), opacity: 0.6 }}>
                {message}
            </Typography>
            <DialogActions sx={{ padding: getPxAsRem(8) }}>
                <Button variant="text" onClick={onLeaveClick}>
                    Leave
                </Button>
                <Button onClick={onStayClick}>Stay</Button>
            </DialogActions>
        </Dialog>
    )
}

export default UnsavedChangesModal
